// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yy3pvB_x340AarAic8mv:before,.snZLkFz4Op31lX5qMip4{color:var(--redDark)!important}.vGIe0GvoRrwBKzoO9xaE:before{color:var(--green20)!important}html[dir] .vGIe0GvoRrwBKzoO9xaE:before{margin-bottom:2px}.DIwrUbpGJXQWWDwDjnfC{color:var(--green20)!important}.cKfNtjTBtmQd2iAraQ6v:before,.kbgKtnO6scP8odFoaBQn{color:var(--themePrimary)!important}.X_5geEjQxpY76DqMLfjk:before{color:var(--themePrimary)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"redDark": "yy3pvB_x340AarAic8mv",
	"redDarkNext": "snZLkFz4Op31lX5qMip4",
	"snooze": "vGIe0GvoRrwBKzoO9xaE",
	"snoozeNext": "DIwrUbpGJXQWWDwDjnfC",
	"accounts": "cKfNtjTBtmQd2iAraQ6v",
	"accountsNext": "kbgKtnO6scP8odFoaBQn",
	"accountsRead": "X_5geEjQxpY76DqMLfjk"
};
module.exports = ___CSS_LOADER_EXPORT___;
